import styled from 'styled-components';
import BoldCross from '@paradigm/design-system/src/assets/BoldCross';

export const CrossButton = styled.button.attrs({
  type: 'button',
  children: <BoldCross height={8} width={8} css="display: block" />,
})`
  padding: 4px 2px;
  border: 0;
  background: none;
  border-radius: 2px;
  cursor: pointer;
  color: #81868b;
  transition: color 0.16s ease, box-shadow 0.16s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  :hover {
    color: #ddd;
  }
  :focus {
    box-shadow: 0px 0px 0px 1px rgba(255, 255, 255, 0.7);
  }
  :disabled {
    opacity: 0.3;
  }
`;
